import { BrowserRouter, Route, Routes } from "react-router-dom";
import HomePageOne from "./pages/Auth/HomePageOne";

import SubadminPage from "./pages/SubAdmin/SubAdminListPage";
import AddSubadminPage from "./pages/SubAdmin/AddSubAdminPage";
import EditSubadminPage from "./pages/SubAdmin/EditSubadminPage";

import ViewSubadminPage from "./pages/SubAdmin/ViewSubadminPage";
import ErrorPage from "./pages/ErrorPage";
import SignInPage from "./pages/Auth/SignInPage";
import ForgotPasswordPage from "./pages/Auth/ForgotPasswordPage";
import OTPPage from "./pages/Auth/OTPPage";
import ResetPasswordPage from "./pages/Auth/ResetPassword";

import RouteScrollToTop from "./helper/RouteScrollToTop";
import ComingSoonPage from "./pages/ComingSoonPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import MaintenancePage from "./pages/MaintenancePage";
import BlankPagePage from "./pages/BlankPagePage";
import SettingPage from "./pages/Setting/SettingPage";

import FAQPage from "./pages/FAQ/FAQList";
import AddFAQPage from "./pages/FAQ/AddFAQPage";
import EditFAQPage from "./pages/FAQ/EditFAQPage";
import ViewFAQPage from "./pages/FAQ/ViewFAQPage";

import CMSPage from "./pages/CMS/CMSList";
import EditCMSPage from "./pages/CMS/EditCMSPage";
import ViewCMSPage from "./pages/CMS/ViewCMSPage";

import ViewProfilePage from "./pages/Auth/ViewProfilePage";

import CategoryList from "./pages/Category/CategoryList";
import AddCategory from "./pages/Category/AddCategoryPage";
import EditCategory from "./pages/Category/EditCategoryPage";
import ViewCategory from "./pages/Category/ViewCategoryPage";

import PostList from "./pages/Post/PostList";
import ViewPost from "./pages/Post/ViewPostPage";

import UploadPost from "./pages/Post/UploadPost";
import UploadPostList from "./pages/Post/UploadPostList";
import UploadViewPost from "./pages/Post/UploadViewPostPage";
import UploadEditPost from "./pages/Post/EditUploadPost";

import ApprovePostList from "./pages/Post/ApprovePostList";
import ApproveViewPost from "./pages/Post/ApproveViewPostPage";

import RejectPostList from "./pages/Post/RejectedPostList";
import RejectViewPost from "./pages/Post/RejectViewPostPage";
//import ViewCategory from "./pages/Category/ViewCategoryPage";

import SendNotification from "./pages/notification/AddNotification";
import Notification from "./pages/notification/NotificationList";

import Contactus from "./pages/Contactus/Contactus";
import ViewContactus from "./pages/Contactus/ViewContactus";


import Userpage from "./pages/User/UserListPage";
import ViewUserPage from "./pages/User/ViewUserPage";

function App() {
  return (
    <BrowserRouter basename="StreamMate">
      {/* //  <BrowserRouter>  */}
      <RouteScrollToTop />
      <Routes>
        {/* Auth */}
        <Route exact path="/" element={<SignInPage />} />
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/forgotpassword" element={<ForgotPasswordPage />} />
        <Route exact path="/otpverify" element={<OTPPage />} />
        <Route exact path="/resetpassword" element={<ResetPasswordPage />} />

        <Route exact path="/dashboard" element={<HomePageOne />} />
        <Route exact path="/view-profile" element={<ViewProfilePage />} />
        {/******** Sub Admin ***** */}
        <Route exact path="/subadmin" element={<SubadminPage />} />
        <Route
          exact
          path="/subadmin/add-Subadmin"
          element={<AddSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/edit-Subadmin/:id?"
          element={<EditSubadminPage />}
        />
        <Route
          exact
          path="/subadmin/view-Subadmin/:id?"
          element={<ViewSubadminPage />}
        />

        {/******** User ***** */}
        <Route exact path="/user" element={<Userpage />} />
        <Route exact path="/user/view-user/:id?" element={<ViewUserPage />} />

        {/******** Setting ***** */}
        <Route exact path="/settings" element={<SettingPage />} />
        {/******** FAQ ***** */}
        <Route exact path="/faq" element={<FAQPage />} />
        <Route exact path="/faq/add-faq" element={<AddFAQPage />} />
        <Route exact path="/faq/edit-faq/:id?" element={<EditFAQPage />} />
        <Route exact path="/faq/view-faq/:id?" element={<ViewFAQPage />} />
        {/******** CATEGORY ***** */}
        <Route exact path="/category" element={<CategoryList />} />
        <Route exact path="/category/add-category" element={<AddCategory />} />
        <Route
          exact
          path="/category/edit-category/:id?"
          element={<EditCategory />}
        />
        <Route
          exact
          path="/category/view-category/:id?"
          element={<ViewCategory />}
        />

        {/******** Pending Post ***** */}
        <Route exact path="/post" element={<PostList />} />
        <Route exact path="/post/view-post/:id?" element={<ViewPost />} />
        {/******** Approve Post ***** */}
        <Route exact path="/approvepost" element={<ApprovePostList />} />
        <Route
          exact
          path="/approvepost/view-post/:id?"
          element={<ApproveViewPost />}
        />
        {/******** Upload Post ***** */}
        <Route exact path="/uploadpost" element={<UploadPostList />} />
        <Route exact path="/uploadpost/add" element={<UploadPost />} />
        <Route
          exact
          path="/uploadpost/view-post/:id?"
          element={<UploadViewPost />}
        />
        <Route
          exact
          path="/uploadpost/edit-post/:id?"
          element={<UploadEditPost />}
        />

        {/******** Reject Post ***** */}
        <Route exact path="/rejectpost" element={<RejectPostList />} />
        <Route
          exact
          path="/rejectpost/view-post/:id?"
          element={<RejectViewPost />}
        />
        {/******** CMS ***** */}
        <Route exact path="/cms" element={<CMSPage />} />
        <Route exact path="/cms/edit-cms/:id?" element={<EditCMSPage />} />
        <Route exact path="/cms/view-cms/:id?" element={<ViewCMSPage />} />

        {/******** Notification ***** */}
        <Route exact path="/notification" element={<Notification />} />
        <Route exact path="/notification/sent" element={<SendNotification />} />

        {/* contactus */}
         <Route exact path="/Contactus" element={<Contactus />} />
         <Route exact path="/Contactus/view-contactus/:id?" element={<ViewContactus />}
        />
        {/* *********** Extra PAges ************ */}
        <Route exact path="/coming-soon" element={<ComingSoonPage />} />
        <Route exact path="/access-denied" element={<AccessDeniedPage />} />
        <Route exact path="/maintenance" element={<MaintenancePage />} />
        <Route exact path="/blank-page" element={<BlankPagePage />} />
        {/* <Route exact path='*' element={<ErrorPage />} /> */}
        <Route exact path="*" element={<ComingSoonPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
